import React, { useRef, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const previews = [{
  image: 'https://cdn.magicpatterns.com/uploads/raLuumyij4MqyAoG7Rrg5x/1_(1).webp',
  book: 'TOM 4',
  title: 'Tydzień 11 — Obrona Strefowa'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/h5XF47GzBVWhvxhAALZLsn/2_(1).webp',
  book: 'TOM 3',
  title: 'Blok 2 — Taktyka Adaptacyjna (Tygodnie 5–8)'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/iXpnhrmuvDfVFj3GccXLEd/3_(1).webp',
  book: 'TOM 3',
  title: 'Tydzień 3 — Libero: Fundamenty'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/f2539V56SgsazB8pdp7sch/4_(1).webp',
  book: 'TOM 2',
  title: 'Załącznik 2B — Księga Rekordów 365'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/pPmRGRBWPzNf3hPaaF9Uux/5_(1).webp',
  book: 'TOM 1',
  title: 'System Stref — „4 Strefy Aktywne"'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/oFfArVRar3zBdSJwWoV9aU/6_(1).webp',
  book: 'TOM 6',
  title: 'Tydzień 8 — TURNIEJ 1'
}];
export function ContentPreview() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div[data-card]')?.clientWidth || 320;
    scrollRef.current.scrollBy({
      left: dir === 'left' ? -(cardWidth + 24) : cardWidth + 24,
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6 overflow-hidden" data-id="element-78">
      <div className="max-w-7xl mx-auto" data-id="element-79">
        <div className="text-center mb-8 md:mb-12" data-id="element-80">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-3 md:mb-4" data-id="element-81">
            Zobacz przykładowe strony wewnątrz
          </h2>
          <p className="text-base md:text-lg text-[#9BA3B5] max-w-3xl mx-auto" data-id="element-82">
            Prawdziwe przykłady stron które znajdziesz w każdym tomie:
            formularze, schematy, checklisty i gotowe tabele.
          </p>
        </div>

        <div className="relative" data-id="element-83">
          <button onClick={() => scroll('left')} className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 rounded-full bg-[#1A3257] border border-[#1E3A5F] shadow-lg items-center justify-center hover:bg-gold-accent hover:text-[#0A1628] text-white transition-colors" aria-label="Przewiń w lewo" data-id="element-84">
            <ChevronLeft className="w-6 h-6" data-id="element-85" />
          </button>
          <button onClick={() => scroll('right')} className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 rounded-full bg-[#1A3257] border border-[#1E3A5F] shadow-lg items-center justify-center hover:bg-gold-accent hover:text-[#0A1628] text-white transition-colors" aria-label="Przewiń w prawo" data-id="element-86">
            <ChevronRight className="w-6 h-6" data-id="element-87" />
          </button>

          <div ref={scrollRef} className="flex gap-4 md:gap-6 overflow-x-auto snap-x snap-mandatory pb-6 px-4 -mx-4 scroll-smooth" style={{
          scrollbarWidth: 'thin'
        }} data-id="element-88">
            {previews.map((preview, index) => <div key={index} data-card className="snap-center flex-shrink-0 w-[260px] sm:w-[280px] md:w-[340px] bg-[#1A3257] rounded-2xl shadow-lg overflow-hidden border border-[#1E3A5F]" data-id="element-89">
                <div className="relative bg-[#0A1628] aspect-[3/4] overflow-hidden" data-id="element-90">
                  <img src={preview.image} alt={`Przykładowa strona z ${preview.book} — ${preview.title}`} loading="lazy" decoding="async" className="w-full h-full object-cover opacity-90" data-id="element-91" />
                  <div className="absolute top-3 left-3 bg-gold-accent text-[#0A1628] text-xs md:text-sm font-bold px-3 py-1.5 rounded-full shadow-md" data-id="element-92">
                    {preview.book}
                  </div>
                </div>
                <div className="p-4 md:p-5" data-id="element-93">
                  <h3 className="font-display font-bold text-white text-base md:text-lg leading-snug" data-id="element-94">
                    {preview.title}
                  </h3>
                </div>
              </div>)}
            <div className="flex-shrink-0 w-1" aria-hidden="true" data-id="element-95" />
          </div>
        </div>

        <p className="text-center text-[#9BA3B5] text-xs sm:text-sm mt-2 md:hidden" data-id="element-96">
          ← Przewiń aby zobaczyć więcej →
        </p>
      </div>
    </section>;
}